import { Table } from 'antd';
import { useMemo } from 'react';

import type { TComparisonTable as TComparisonTableData } from '@/models/chat.model';

import { getComparisonRowLabel, getComparisonTableColumns } from '../../helpers';
import type { TComparisonRowRecord } from '../../helpers';
import {
  StyledComparisonTableScroll,
  StyledComparisonTableTitle,
  StyledComparisonTableWrapper,
} from './ComparisonTableStyles';

export interface IComparisonTableProps {
  data?: TComparisonTableData;
  primaryColor?: string;
}

const ComparisonTable = ({ data, primaryColor }: IComparisonTableProps) => {
  const columns = useMemo(() => (data ? getComparisonTableColumns(data, primaryColor) : []), [data, primaryColor]);

  const dataSource: TComparisonRowRecord[] = useMemo(() => {
    if (!data) return [];

    return data.rows.map((row) => ({
      key: row.name ? `${row.key}-${row.name}` : row.key,
      rowKey: row.key,
      label: getComparisonRowLabel(row),
      ...row.values,
    }));
  }, [data]);

  if (!data?.rows?.length) return null;

  return (
    <StyledComparisonTableWrapper>
      <StyledComparisonTableTitle>Comparison Table</StyledComparisonTableTitle>
      <StyledComparisonTableScroll>
        <Table
          columns={columns}
          dataSource={dataSource}
          size="small"
          pagination={false}
          bordered
          scroll={{ x: true }}
        />
      </StyledComparisonTableScroll>
    </StyledComparisonTableWrapper>
  );
};

export default ComparisonTable;
